export default __webpack_public_path__ + "static/media/cut-glass.bd15fa1f.png";